import { Component, Input, Output, EventEmitter, ContentChild, TemplateRef } from '@angular/core';

import { DomHandler } from 'primeng/dom';

import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { LocalizeStringModel } from '../../../Localization/models/localize-string.model';


@Component({
    selector: 'agpr-dialog-container',
    templateUrl: './dialog-container.component.html',
    styleUrls: ['./dialog-container.component.scss'],
    standalone: false
})
export class DialogContainerComponent {

    @Input() id: string;
    @Input() heading: string|LocalizeStringModel;
    @Input() headingIcon: string;
    @Input() modal: boolean = true;
    @Input() showClose: boolean = true;
    @Input() contentPadding: boolean = true;
    @Input() hideFooter: boolean = false;
    @Input() clickOutside: boolean = false;
    @Input() closeOnClickOutside: boolean = true;
    @Input() showLoadingHeader: boolean = false;
    @Input() showHeader: boolean = true;
    @Input() hideRows: boolean = false;
    @Input() noMargin: boolean = false;
    @Input() fitContent: boolean = false;

    @ContentChild('header') header: TemplateRef<any>;
    @ContentChild('footer') footer: TemplateRef<any>;
    @ContentChild('footerLeft') footerLeft: TemplateRef<any>;
    @ContentChild('footerRight') footerRight: TemplateRef<any>;

    @Output() close: EventEmitter<void> = new EventEmitter<void>();

    zIndex: number;

    readonly buttonTypes = ButtonTypesEnum;

    constructor() {
        // Using the z-index the way PrimeNG uses it to make sure there are no conflicts
        this.zIndex = ++DomHandler.zindex;
    }

    closeDialog(event) {
        if (this.closeOnClickOutside && event.target.classList.contains('agpr-dialogOverlay')) {
            this.close.emit();
        }
    }
}
